import { render, staticRenderFns } from "./BatchCreate.vue?vue&type=template&id=448a396e&scoped=true&"
import script from "./BatchCreate.vue?vue&type=script&lang=js&"
export * from "./BatchCreate.vue?vue&type=script&lang=js&"
import style0 from "./BatchCreate.vue?vue&type=style&index=0&id=448a396e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448a396e",
  null
  
)

export default component.exports